<spinner *ngIf="loading"></spinner>

<form [formGroup]="formGroup">

    <h6 class="mt-2 mb-0 fw-bold">Team</h6>
    <hr class="mt-2 mb-4" />

    <div class="row">
        <div class="col-md-4">
            <div class="form-group mb-3">
                <label class="form-label" for="reg-organisation">Organisation <span class="text-red">*</span></label>
                <ng-select labelForId="reg-organisation" placeholder="Select one option" formControlName="organisation" [clearable]="false" [searchable]="true">
                    <ng-option [value]="''">Select one option</ng-option>
                    @for (organisation of organisationList; track organisation) {
                        <ng-option [value]="organisation.id">{{organisation.name}}</ng-option>
                    }
                </ng-select>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group mb-3">
                <label class="form-label" for="reg-service">Service <span class="text-red">*</span></label>
                <ng-select labelForId="reg-service" placeholder="Select one option" formControlName="service" [clearable]="false" [searchable]="true">
                    <ng-option [value]="''">Select one option</ng-option>
                    @for (service of serviceList; track service) {
                        <ng-option [value]="service.id">{{service.name}}</ng-option>
                    }
                </ng-select>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group mb-3">
                <label class="form-label" for="reg-department">Team <span class="text-red">*</span></label>
                <ng-select labelForId="reg-department" placeholder="Select one option" formControlName="department" [clearable]="false" [searchable]="true">
                    <ng-option [value]="''">Select one option</ng-option>
                    @for (department of departmentList; track department) {
                        <ng-option [value]="department.id">{{department.name}}</ng-option>
                    }
                </ng-select>
            </div>
        </div>
        <div class="col-md-4" *ngIf="isAdmin && patient == null">
            <div class="form-group mb-3">
                <label class="form-label" for="reg-clinician">Clinician <span class="text-red">*</span></label>
                <ng-select labelForId="reg-clinician" placeholder="Select one option" formControlName="clinician" [clearable]="false" [searchable]="true">
                    <ng-option [value]="''">Select one option</ng-option>
                    @for (clinician of clinicianList; track clinician) {
                        <ng-option [value]="clinician.id">{{clinician.user.firstName}} {{clinician.user.lastName}}</ng-option>
                    }
                </ng-select>
            </div>
        </div>
        <!-- UNIVAPLAT-2827: edit mode — the clinician is only assigned when an administrator
             registered the patient. Show the assignment read-only when it exists; hide the
             field entirely when the patient has no assigned clinician. -->
        <div class="col-md-4" *ngIf="patient != null && assignedClinicianName">
            <div class="form-group mb-3">
                <label class="form-label">Clinician</label>
                <input class="form-control" type="text" [value]="assignedClinicianName" disabled />
            </div>
        </div>
    </div>

    <h6 class="mt-2 mb-0 fw-bold">Account Information</h6>
    <hr class="mt-2 mb-4" />

    <div class="row">
        <div class="col-md-4">
            <div class="form-group mb-3">
                <label class="form-label" for="reg-type-of-user">Type of user(s) <span class="text-red">*</span></label>
                <ng-select labelForId="reg-type-of-user" dropdownPosition="top" placeholder="Select one option" formControlName="typeOfUser" [clearable]="false" [searchable]="false">
                    <ng-option [value]="''">Select one option</ng-option>
                    <ng-option value="Patient">Patient</ng-option>
                    <ng-option value="Carer">Carer</ng-option>
                    <ng-option value="Patient and carer">Patient and Carer</ng-option>
                </ng-select>
            </div>
            <div class="form-check mb-3" *ngIf="isAdmin && patient == null">
                <input class="form-check-input" type="checkbox" id="isTest" formControlName="isTest">
                <label class="form-check-label" for="isTest">Mark as tester</label>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group mb-3">
                <label class="form-label" for="reg-feature-set">Feature set <span class="text-red">*</span></label>
                <ng-select labelForId="reg-feature-set" dropdownPosition="top" placeholder="Select one option" formControlName="featureSet" [clearable]="false" [searchable]="false">
                    @for (license of licenseList; track license) {
                        <ng-option [value]="license.id">{{license.name}}</ng-option>
                    }
                </ng-select>
            </div>
        </div>
    </div>
</form>
